import { render, staticRenderFns } from "./campus-recruitments.vue?vue&type=template&id=b09c6b9c&scoped=true"
import script from "./campus-recruitments.vue?vue&type=script&lang=js"
export * from "./campus-recruitments.vue?vue&type=script&lang=js"
import style0 from "./campus-recruitments.vue?vue&type=style&index=0&id=b09c6b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09c6b9c",
  null
  
)

export default component.exports